import { ReactComponent as ArrowUpIcon } from "@/assets/svgs/arrow-up.svg";
import DexLeftComponent from '@/components/DexLeftComponent';
import Toast2 from "@/components/Toast2";
import { useNavigate } from '@/lib/router-dom';
import API_HEALTH from "@/services/api/health";
import "@/translations/i18n";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

const SoftwareUpdate = () => {

	const [error, setError] = useState();
	function handleError() {
		setError();
	}

	const dispatch = useDispatch()

	const dataRef = useRef(false);

	const [readMore, setReadMore] = useState(true);
	const [textPart1, setTextPart1] = useState("");
	const [textPart2, setTextPart2] = useState("");

	const months = {
		0: "Jan",
		1: "Feb",
		2: "Mar",
		3: "Apr",
		4: "May",
		5: "Jun",
		6: "Jul",
		7: "Aug",
		8: "Sep",
		9: "Oct",
		10: "Nov",
		11: "Dec",
	};

	const version = useSelector((state) => state.version.data);

	useEffect(() => {
		// call health api to get version
		if (!dataRef.current) {
			dataRef.current = true;
			API_HEALTH.index();
		}
	});

	useEffect(() => {
		const _txt = version.description || "";

		// Pivot to cut text content
		const pivot = 200;
		setTextPart1(() => _txt.substring(0, pivot));
		setTextPart2(() => _txt.substring(pivot, _txt.length));

		// Redirect if version up to date
		if (version.status === "OK") {
			goTo("/");
		}

		if (version.status === "NOT_OK") {
			dispatch({ type: 'auth/logout' });
		}
	}, [version]);

	const { goTo } = useNavigate();

	function onSkipBtnClick() {
		goTo(`/`);
	}

	function onReadMoreLessBtnClick() {
		setReadMore((prevState) => !prevState);
	}

	function getReadMoreBtnText() {
		return readMore ? "Read More" : "Read Less";
	}

	function getReleaseDate() {
		const d = version.releaseDate
			? new Date(version.releaseDate)
			: new Date();
		return `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}`;
	}

	function onViewDetailBtnClick() {
		const releaseNotesUrl = version?.releaseNotesUrl || "https://sgtradex.com/";
		window.open(releaseNotesUrl);
	}

	return (
		<>
			<div className="layout-login">
				<DexLeftComponent />

				<div className="layout-login__right">
					<div className="login-box">
						<div className="software-update-box__title">
							Software Update
						</div>
						<div className="software-update-box__desc">
							New version of Pitstop released on{" "}
							{getReleaseDate()}. Talk to your tech team to upgrade
							the pitstop.
						</div>
						<div className="software-update-box__subtitle">
							What's New
						</div>

						<div className="software-update-box__content-group">
							<div className="software-update-box__content">
								{textPart1}
							</div>

							{readMore ? (
								<div className="software-update-box__content software-update-box__dot">
									...
								</div>
							) : (
								<div className="software-update-box__content">
									{textPart2}
								</div>
							)}

							<div
								className="software-update-box__content software-update-box__read_more_less"
								onClick={onReadMoreLessBtnClick}
							>
								{getReadMoreBtnText()}
							</div>
						</div>

						<div className="_version-card">
							<div className="_version-card-detail-group">
								<ArrowUpIcon />
								<div className="_version-card-detail-text">
									Pitstop Software
								</div>
							</div>

							<button
								className="_view-detail-btn"
								onClick={onViewDetailBtnClick}
							>
								View Details
							</button>
						</div>

						{(version?.status === "OK" ||
							version?.status === "UPDATE_AVAILABLE") && (
							<button
								className="_btn-skip-software-update"
								onClick={onSkipBtnClick}
							>
								SKIP
							</button>
						)}
					</div>
				</div>
				<Toast2
					show={error}
					errorMessage={error}
					close={() => {
						handleError();
					}}
				/>
				<div className="version__no">
					v{version?.pitstopVersion}
				</div>
			</div>
		</>

	);
};

export default SoftwareUpdate;
